import styled from 'styled-components';
export const Wrapper = styled.div ``;
export default {
    Wrapper,
};
